"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _TableBody = _interopRequireDefault(require("./TableBody.style"));

var _dec, _class;

let TableBody = (_dec = (0, _reactJss.default)(_TableBody.default), _dec(_class = class TableBody extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      className,
      classes,
      children,
      columnSize
    } = this.props;
    return _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.tableBody, className)
    }, _react.default.Children.map(children, child => _react.default.cloneElement(child, {
      columnSize
    })));
  }

}) || _class);
TableBody.defaultProps = {
  visibility: 'visible',
  columnSize: {}
};
var _default = TableBody;
exports.default = _default;